// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @components
const { HireCardImageSelector } = require('components/hire/hireCardImageSelector/hireCardImageSelector');
const HireCardNameSelector = require('components/hire/hireCardNameSelector/hireCardNameSelector');

// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ constants
const { CREDIT_CARD_REVOLVING_PROCESS } = require('constants/flagBasedFeatures');

class HireCreditCardStep2 extends React.Component {

    render() {
        const {
            extraImage,
            getContextTranslate,
            immFlagBasedFeatures,
            immHireCardImageSelector,
            immHireCardNameSelector,
            hireCreditCard,
            getContextKeyTranslate,
            cardType
        } = this.props;
        const cardImageIds = hireCreditCard.get('cardImageIds')
        const disclaimerPersonalInfoUrl = formatText(getContextTranslate('disclaimerPersonalInfoLinkUrlNeruda'));

        return (
            <article className="hire-card-neruda__step-two">
                <FormattedText
                    className="hire-card-neruda__step-title"
                    value={getContextTranslate('step2Title')}
                />
                <HireCardImageSelector
                    cardImageIds={cardImageIds.toJS()}
                    extraClass="hire-card-diamond-pack__card-image-selector"
                    extraImage={extraImage}
                    immHireCardImageSelector={immHireCardImageSelector}
                    customTitle={cardType === ('vanity' || 'neruda') && 'hireCardImageSelector-hireCardImageSelector_titleOneCardNeruda'}
                />
                <HireCardNameSelector
                    borderTop={true}
                    immHireCardNameSelector={immHireCardNameSelector}
                />
                {immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS) &&
                    <OKMessage type="informative">
                        <FormattedText value={getContextKeyTranslate('step2Informative')} />
                        &nbsp;
                        <OKLink modifier="emphasize" to={disclaimerPersonalInfoUrl} target="_blank">
                            <FormattedText value={getContextKeyTranslate('step2Emphasize')} />
                        </OKLink>
                    </OKMessage>
                }
            </article>
        );
    }
}

HireCreditCardStep2.propTypes = {
    extraImage: PropTypes.string,
    getContextTranslate: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    hireCreditCard: PropTypes.object.isRequired,
};

module.exports = HireCreditCardStep2;
